/* eslint-disable */
import {
	getHigherUnitAndQuantity,
	getHigherUnitName,
	getUnitConvertedUnit,
} from '@/Helpers';
export const staticTableTransformers = {
	longTermProduction: (
		modeConfig,
		productList = [],
		batches = [],
		state,
		lists,
		tableData
	) => {
		const rows = [];
		const headers = modeConfig.tableColumns || [];
		const filteredProductList = productList?.filter((product) =>
			['PRODUCT', 'UNPACKED_PRODUCT'].includes(product?.skuType)
		);

		const existingQtyMap = new Map();
		tableData?.rows?.forEach((row) => {
			if (row._variantId) {
				existingQtyMap.set(row._variantId, row.qty);
			}
		});

		filteredProductList?.forEach((product) => {
			product?.variants?.forEach((variant) => {
				const batchInfo = batches?.find(
					(b) => b.variantId === variant.id
				);
				rows.push({
					'S.No': rows.length + 1,
					productName: `${product?.productName} (${variant?.displayName})`,
					clientVariantId: variant?.clientVariantId || '',
					unit: getHigherUnitName(product?.unit) || '',
					batch:
						getHigherUnitAndQuantity(
							product?.unit,
							batchInfo?.batchSize,
							false
						)?.[0] || '',
					qty: existingQtyMap.get(variant.id) || '',
					Actions: { rowIndex: rows.length },
					originalUnit: product?.unit,
					_variantId: variant?.id,
					_productId: product?.id,
				});
			});
		});
		return {
			headers,
			rows,
		};
	},
	buyerOrder: (
		modeConfig,
		productList = [],
		batches = [],
		state,
		lists,
		tableData
	) => {
		if (state?.buyer?.length === 0) {
			return {
				headers: [],
				rows: [],
			};
		}
		let locationHeaders = [];
		if (state?.buyer?.length > 0) {
			lists?.buyerList?.forEach((buyer) => {
				const isBuyerSelected = state?.buyer?.includes(buyer?.id);
				if (buyer?.vendor_locations?.length > 0) {
					buyer?.vendor_locations?.forEach((location) => {
						const locationId = `${buyer.id}_${location.id}`;
						const isLocationSelected = state?.buyer?.includes(
							location?.id
						);
						if (isBuyerSelected || isLocationSelected) {
							locationHeaders.push({
								name: location?.name,
								id: locationId,
								groupName: buyer?.label || buyer?.name,
							});
						}
					});
				}
			});
		}
		const headers = [
			...modeConfig.tableColumns,
			...locationHeaders,
			{ name: 'Total', id: 'Total' },
			{ name: 'Actions', id: 'Actions' },
		];
		let rows = tableData?.rows || [];
		if (rows.length > 0) {
			const standardKeys = [
				'S.No',
				'Item Name',
				'itemId',
				'SkuCode',
				'originalUnit',
				'Total',
				'Actions',
				'_variantId',
				'_productId',
			];
			const activeLocationIds = locationHeaders.map((h) => h.id);
			const validKeys = [...standardKeys, ...activeLocationIds];

			rows = rows.map((row) => {
				const updatedRow = {};
				// Only preserve valid keys
				Object.keys(row).forEach((key) => {
					if (validKeys.includes(key)) {
						updatedRow[key] = row[key];
					}
				});

				// Add missing location keys
				locationHeaders.forEach((header) => {
					if (!updatedRow[header.id]) {
						updatedRow[header.id] = {
							qty: '',
							unit: getUnitConvertedUnit(
								null,
								row.originalUnit,
								true
							),
							storeId: header.id,
							itemId: row.itemId || row._variantId,
							productId: row.productId || row._productId,
						};
					}
				});
				return updatedRow;
			});
		}
		return { headers, rows, apiStoreList: locationHeaders };
	},
	orderWiseEdit: (
		modeConfig,
		productList = [],
		batches = [],
		state,
		lists,
		selectedPOs = []
	) => {
		// Create headers: Fixed columns + One column per PO
		const poHeaders = selectedPOs.map((po) => ({
			orderId:
				po?.clientPoId && po?.clientPoId.length > 10
					? `${po?.clientPoId.substring(0, 10)}...`
					: po?.clientPoId || po?.id,
			id: po?.id, // PO ID acts as the key
			name: po?.storeName,
			priority: po?.priority ?? false,
			_storeId: po?.storeId,
		}));

		const headers = [
			{ name: 'S.No', id: 'S.No' },
			{ name: 'Item Name', id: 'Item Name' },
			{ name: 'SkuCode', id: 'SkuCode' },
			...poHeaders,
			{ name: 'Total', id: 'Total' },
			{ name: 'Actions', id: 'Actions' },
		];

		// Aggregate items across all POs
		const itemMap = new Map();

		selectedPOs?.forEach((po) => {
			po?.items?.forEach((item) => {
				const key = item?.variantId;
				if (!itemMap.has(key)) {
					itemMap.set(key, {
						itemDetails: item, // item name, skucode, etc.
						quantities: {}, // map of poId -> item data
					});
				}
				const entry = itemMap.get(key);
				entry.quantities[po.id] = {
					qty: item.qty,
					unit: item.unit,
					itemId: item.variantId,
					productId: item.productId,
					storeId: po.storeId, // Keep storeId for reference
				};
			});
		});

		// Create rows
		const rows = Array.from(itemMap.values()).map((entry, index) => {
			const { itemDetails, quantities } = entry;
			const row = {
				'S.No': index + 1,
				'Item Name': `${itemDetails?.productName} (${itemDetails?.variantName || ''
					})`,
				SkuCode:
					itemDetails?.skuCode || itemDetails?.clientVariantId || '',
				itemId: itemDetails?.variantId,
				_variantId: itemDetails?.variantId,
				_productId: itemDetails?.productId,
				originalUnit: itemDetails?.unit,
				Actions: { rowIndex: index },
				Total: '', // Can calculate total if needed, leaving empty for now matching other modes
			};

			// Populate PO columns
			poHeaders.forEach((header) => {
				if (quantities[header.id]) {
					row[header.id] = quantities[header.id];
				} else {
					// Empty cell for this PO
					row[header.id] = {
						qty: '',
						unit: getUnitConvertedUnit(
							null,
							itemDetails?.unit,
							true
						),
						itemId: itemDetails?.variantId,
						productId: itemDetails?.productId,
						storeId: header._storeId,
					};
				}
			});

			return row;
		});

		return { headers, rows };
	},
};

export const getStaticTableData = (
	modeName,
	modeConfig,
	productList,
	batches = [],
	state,
	lists,
	tableData
) => {
	if (!modeConfig?.tableDataStatic) {
		return { headers: [], rows: [], apiStoreList: [] };
	}
	const transformer = staticTableTransformers[modeName];
	const {
		headers,
		rows,
		apiStoreList = [],
	} = transformer
			? transformer(modeConfig, productList, batches, state, lists, tableData)
			: { headers: [], rows: [], apiStoreList: [] };

	return { headers, rows, apiStoreList };
};
